import { useEffect } from 'react'

import { capitalize } from 'lodash'
import { AccordionListContent, AccordionListItem, AccordionListTrigger, Label, List, ListItem } from 'twyne-new.ui'

import { useEditing } from '@/modules/cms/views/post/components/builder/context'

export default function BlockList({ store, title }) {
  const { items, handleLoad } = store

  useEffect(() => {
    handleLoad()
  }, [handleLoad])

  return <>
    <AccordionListItem value={title}>
      <AccordionListTrigger>{capitalize(title)}</AccordionListTrigger>
      <AccordionListContent>

        <List>
          {items.map((item, idx) => <div
            key={idx}
          // ref={ref => create(ref, element)}
          >
            <ListItem
              className='flex-col gap-2'
              value={<>
                <img src={`https://picsum.photos/100/30?random=${idx}`} />
                <Label>{item.name}</Label>
              </>}
            />
          </div>)}
        </List>
      </AccordionListContent>
    </AccordionListItem>
  </>
}

function Item({ data, onDelete }) {
  const { value: editing, set: setEditing } = useEditing()

  const handleSelect = () => {
    setEditing(data)
  }

  const handleRemove = async evt => {
    evt.stopPropagation()
    await onDelete(data)
    setEditing()
  }

  return <>
    <ListGroup className='py-1 pointer' onClick={handleSelect}>
      <ListGroupItem className='py-2 px-3' active={editing?.id === data.id}>
        {data.name}
        <Button close onClick={handleRemove} />
      </ListGroupItem>
    </ListGroup>
  </>
}

function AddButton({ defaultValue, title, onSave }) {
  const [name, setName] = useState('')
  const id = `add-button-${btoa(useId()).replace(/=/g, '')}`

  const handleAdd = async () => {
    await onSave(defaultValue(name))
  }

  return <>
    <Button color='primary' outline size='sm' id={id}>
      {title}
    </Button>
    <UncontrolledPopover trigger="legacy" placement="bottom" target={id}>
      <PopoverHeader>Save</PopoverHeader>
      <PopoverBody>
        <Row>
          <Col sm="12">
            <FormGroup>
              <Label>Name</Label>
              <Input required name="name" value={name}
                onChange={e => setName(e.target.value)} />
            </FormGroup>
          </Col>
          <Col>
            <Button size="sm" color="success" block onClick={handleAdd}>Add</Button>
          </Col>
        </Row>
      </PopoverBody>
    </UncontrolledPopover >
  </>
}

